export const getV3Url = (path: string) => process.env.REACT_APP_CLIENT_V3_HOST + path
